import React from "react";
var defaultValue = {
  store: {
    client: {},
    checkout: {
      lineItems: [],
      totalPrice: 0
    },
    checkoutEditable: true
  },
  currentTotalQuantity: function currentTotalQuantity() {},
  addVariantToCart: function addVariantToCart() {},
  updateLineItemQuantity: function updateLineItemQuantity() {},
  removeLineItem: function removeLineItem() {},
  proceedToCheckout: function proceedToCheckout() {}
};
var StoreContext = /*#__PURE__*/React.createContext(defaultValue);
export default StoreContext;